import { Button, Tooltip } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteOutlined } from '@mui/icons-material';
import IconButton from '@/components/@extended/IconButton';
import { ConfirmDialog } from '../confirm-dialog';
import { IDeleteModalProps } from './types';

export const DeleteModal: FC<IDeleteModalProps> = ({
	children,
	onDelete,
	title,
	isIcon = true,
	buttonProps,
	isDisabled = false
}) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = (): void => {
		setOpen(true);
	};

	const handleClose = (): void => {
		setOpen(false);
	};

	const handleDelete = (): void => {
		onDelete();
		setOpen(false);
	};

	return (
		<>
			{isIcon ? (
				<Tooltip title={t('modals.delete.tooltip')}>
					<span>
						<IconButton
							variant="light"
							color="error"
							onClick={handleClickOpen}
							disabled={isDisabled}
							{...buttonProps}
							sx={{
								width: 36,
								height: 36,
								minWidth: 36,
								p: 0,
								backgroundColor: 'transparent',
								'& .MuiSvgIcon-root': { fontSize: 16 },
								// disabled → fără fundal/bordură (doar iconița estompată)
								'&.Mui-disabled': {
									backgroundColor: 'transparent',
									border: 'none'
								}
							}}
						>
							<DeleteOutlined />
						</IconButton>
					</span>
				</Tooltip>
			) : (
				<Button
					variant="contained"
					disabled={isDisabled}
					onClick={handleClickOpen}
					{...buttonProps}
				>
					{t('common.delete')}
				</Button>
			)}
			<ConfirmDialog
				open={open}
				title={title}
				description={children}
				confirmText={t('common.delete')}
				cancelText={t('common.cancelUppercase')}
				color="error"
				icon={<DeleteOutlined />}
				onConfirm={handleDelete}
				onClose={handleClose}
			/>
		</>
	);
};
